import { previewMode } from 'utils/dynamicData';
import { addSlashes, mapBanner } from 'utils/cms/utils';

function mapBg(cmsData) {
	const onesheetUrl = cmsData?.pages?.showtimes?.onesheet?.custom ? cmsData.pages.showtimes.onesheet.url : cmsData?.onesheet?.url;
	const headerImageUrl = cmsData?.pages?.showtimes?.headerImage?.custom ? cmsData.pages.showtimes.headerImage.url : cmsData?.headerImage?.url;

	return {
		desktop: { asset: onesheetUrl },
		mobile: { asset: headerImageUrl },
		tablet: { asset: headerImageUrl },
		tabletLandscape: { asset: headerImageUrl },
	};
}

function mapQuickFilters(cmsData) {
	const quickFiltersData = cmsData?.pages?.showtimes?.quickFilters;
	if (!quickFiltersData) return {};

	const enabledFilters = Object.keys(quickFiltersData).filter(format => quickFiltersData[format]).join(',');

	if (!enabledFilters) return {};

	return {
		visibleDesktop: true,
		visibleMobile: true,
		title: cmsData?.pages?.showtimes?.quickFiltersText || 'Formats',
		displayOptions: {
			format: enabledFilters,
		},
	};
}

export default function mapShowtimes(cmsData, appData) {
	if (!appData?.pages?.boltShowtimes) return null;

	const showtimesData = cmsData?.pages?.showtimes;
	// Allow preview mode for non-active pages, but only if that is the page being previewed (directly accessed by URL)
	const showInactive = previewMode && location.pathname.endsWith('/tickets/');
	if (!showtimesData?.active && !showInactive) return null;

	const isDefault = showtimesData?.settings?.default ?? false;

	return {
		disabled: false,
		type: 'showtimes',
		data: {
			bg: mapBg(cmsData),
			buttons: {},
			movieId: cmsData.showtimesId,
			notificationBanner: mapBanner(showtimesData?.banner),
			quickFilters: mapQuickFilters(cmsData),
		},
		isMainPage: isDefault,
		path: isDefault ? '/' : undefined, // Only set path to '/' if this is the default page, otherwise let Bolt determine the path based on the page key (e.g. '/showtimes')
		// When this page is the default, keep the original path so nav links and URL detection still resolve to it
		...(isDefault ? { additionalPaths: '/tickets/', alternatePaths: '/tickets/' } : {}),
	};
}